import i18n from "../i18n";

export const LICENSE_TYPES: { [key: string]: string } = {
    "USER": i18n.t('users'),
    "SMARTCREDENTIAL": i18n.t('smart-credentials'),
    "MOBILE_SMARTCREDENTIAL": i18n.t('smart-credentials-mobile'),
    "SMARTCREDENTIAL_IDENTITY_ASSURED": i18n.t('smart-credential-identity-assured')
}

export const GET_NOTIFICATIONS_LAPSE = 120000;